import { render } from "./BaseFormGroup.vue?vue&type=template&id=0dd5a7a7&scoped=true"
import script from "./BaseFormGroup.vue?vue&type=script&lang=js"
export * from "./BaseFormGroup.vue?vue&type=script&lang=js"

import "./BaseFormGroup.vue?vue&type=style&index=0&id=0dd5a7a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd5a7a7"]])

export default __exports__